// Runtime webpack patch for missing core-js modules
import "./src/polyfills/webpack-runtime-patch";

// Silence ResizeObserver "loop completed with undelivered notifications" —
// a benign Chrome scheduling signal that webpack-dev-server's runtime overlay
// otherwise treats as a crash. Must register handlers before app code mounts
// so ReactFlow's first measure pass doesn't slip past us.
import "./src/polyfills/resize-observer-silence";

// React 19 compatibility polyfill
import "./src/polyfills/react19-ref-polyfill";
import "./common/react19-polyfill";

// Import core-js modules individually to avoid web.atob
import "core-js/es";
import "core-js/web/dom-collections";
import "core-js/web/dom-exception";
import "core-js/web/immediate";
import "core-js/web/queue-microtask";
import "core-js/web/structured-clone";
import "core-js/web/timers";
import "core-js/web/url";
import "core-js/web/url-search-params";
// Note: Skipping core-js/web (which includes web.atob) - we provide our own atob/btoa polyfill
import "./src/polyfills/core-js-polyfill";
import React from "react";
import ReactDOM from "./src/polyfills/patch-react-dom";

import sortable from "jquery-ui/ui/widgets/sortable";
import ReduxProvider from "./_editor/containers/ReduxProvider";
import AppErrorBoundary from "./_editor/containers/AppErrorBoundary";
// Import Material Icons CSS for font support
import "material-design-icons-font/iconfont/material-icons.css";
// It appears as unused, but it IS used.
import i18n from "./locales/i18n";
import "./core/editor/temp_hack";
import { getToken, assetGrantReady } from "./common/environment_config.es6";
import { bootEditor } from "./common/bootEditor.es6";
import { handleHostSaveMessage } from "./common/hostSaveMessage.es6";
require("./plugins/plugin_dependencies_loader").requireAll();

// Require CSS files
import "./sass/style.scss";

// We make sure JQuery UI Sortable Widget is initialized
// eslint-disable-next-line
new sortable();

// Initialize global AI speech configuration if not defined
window.ai_speech_conf = window.ai_speech_conf || [];
// Initialize global AI image configuration if not defined
window.ai_image_conf = window.ai_image_conf || [];

// Initialize global AI selection variables if not defined
window.aiSelectedVoiceServiceType = window.aiSelectedVoiceServiceType || -1;
window.aiSelectedVoiceLang = window.aiSelectedVoiceLang || "";
window.aiSelectedVoiceName = window.aiSelectedVoiceName || "";

// Import and expose server utilities globally
import * as serverUtils from "./common/server_utils.es6";
import { initializeAIConfigurations, getAIConfiguration } from "./common/ai_config.es6";
import {
  initializeEnvironment,
  getEnvironmentConfig,
  setEnvironmentFromUrl,
  clearStoredEnvironment,
} from "./common/environment_config.es6";

// Expose server utilities globally for compatibility
window._LoadMediaFile = serverUtils._LoadMediaFile;
window._LSUploadHtml = serverUtils._LSUploadHtml;
window._LSCreateUrlHtml = serverUtils._LSCreateUrlHtml;
window._LSCheckLmsStatus = serverUtils._LSCheckLmsStatus;
window._LSPublishToLMS = serverUtils._LSPublishToLMS;
window.ideaEnvSaveState = serverUtils.ideaEnvSaveState;
window._saveAs = serverUtils._saveAs;
window._ideaEnvTtsGetVoice = serverUtils._ideaEnvTtsGetVoice;
window._ideaEnvTtiGetImage = serverUtils._ideaEnvTtiGetImage;
window._LSExitAndReturnList = serverUtils._LSExitAndReturnList;
window._ideaEnvTtsGetVoiceMeta = serverUtils._ideaEnvTtsGetVoiceMeta;
window.escapeRegExp = serverUtils.escapeRegExp;
window.toBase64 = serverUtils.toBase64;

// Expose AI configuration functions
window.initializeAIConfigurations = initializeAIConfigurations;
window.getAIConfiguration = getAIConfiguration;

// Expose environment configuration functions
window.initializeEnvironment = initializeEnvironment;
window.getEnvironmentConfig = getEnvironmentConfig;
window.setEnvironmentFromUrl = setEnvironmentFromUrl;
window.clearStoredEnvironment = clearStoredEnvironment;

// Initialize default SCORM user info
window.scorm_user_fullname = window.scorm_user_fullname || "Anonymous";

// No auto-redirect on boot-with-no-token: AppErrorBoundary shows
// AuthRequiredModal instead, and its "Authenticate" button drives the
// redirect. Visor deployments (index_visor.html) still bypass auth entirely.
const hasValidToken = (function checkAuthToken() {
  const pathname = window.location.pathname;
  const urlParams = new URLSearchParams(window.location.search);

  if (pathname.includes("index_visor.html")) {
    return true;
  }

  // "code" is the one-time session-code hand-off (exchanged for a real token
  // by setEnvironmentFromUrl below); "token" is the legacy raw-JWT fallback.
  const hasTokenInUrl = urlParams.has("token") || urlParams.has("code");
  const storedToken = getToken();

  return hasTokenInUrl || !!storedToken;
})();

// Listen for messages from parent window (when embedded in iframe)
window.addEventListener("message", handleHostSaveMessage);

// // Populate AI configurations with subscription data
// if (window.ai_speech_conf.length === 0) {
//   window.ai_speech_conf.push({
//     name: "OpenAI - ElevenLabs",
//     value: 1,
//     lang: [
//       {
//         name: "tr-TR",
//         voices: [
//           { name: "Erkek - * Dağhan Aslanger", value: "InTcBOYbBDjVPg15q0rr" },
//           { name: "Erkek - * Emre Gökçe", value: "dNjajZuUYmsgcT357Rhg" },
//           { name: "Erkek - * Kemal Uğurlu", value: "x5J0w1JGs0MQNyzjoYDc" },
//           { name: "Erkek - * Yiğit Atilla", value: "oOSiVtAFJQH0fw31A1we" },
//           { name: "Erkek - Asım Mirza Ciftler", value: "mEf7WY0hvNO6KqdAkUeA" },
//           { name: "Erkek - Burak Yoğlu", value: "KUfkSkLgALXbMGlHysRz" },
//           { name: "Erkek - Süleyman HQ", value: "LToDY4cXEoKGCUVBdZcd" },
//           { name: "Erkek - Süleyman Manasırlı", value: "xbkTDhi4jaCwAxBBIavC" },
//           { name: "Kadın - *Hicran Vuslat", value: "6CXMImQW1F1c4NFd7zKd" },
//           { name: "Kadın - *Hülya", value: "VqMgRfup79a9L4ee93oH" },
//           { name: "Kadın - *Hürrem", value: "TASY7VCrU29rEMoYFTGG" },
//           { name: "Kadın - *Tomris", value: "bqaNYmxFgK1TN7CL95PZ" },
//           { name: "Kadın - Arden", value: "oPe2OnAkyZouGbVh45Ku" },
//           { name: "Kadın - Elif", value: "mnEe2Jhwlupp6oZEDi3k" },
//           { name: "Kadın - Sevim", value: "H9xk2HncwpOKhhzbyWsd" },
//           { name: "Kadın - Sevimcast", value: "LYfSi2g3Frvxg50fRl91" },
//         ],
//       },
//       {
//         name: "en-US",
//         voices: [
//           { name: "Male - Antoni", value: "ErXwobaYiN019PkySvjV" },
//           { name: "Male - Bill", value: "pqHfZKP75CvOlQylNhV4" },
//           { name: "Male - Charlie", value: "IKne3meq5aSn9XLyUdCD" },
//           { name: "Male - George", value: "JBFqnCBsd6RMkjVDRZzb" },
//           { name: "Male - Josh", value: "TxGEqnHWrfWFTfGW9XjX" },
//           { name: "Female - Dorothy", value: "ThT5KcBeYPX3keUQqHPh" },
//           { name: "Female - Grace", value: "oWAxZDx7w5VEj9dCyTzz" },
//           { name: "Female - Matilda", value: "XrExE9yKIg1WjnnlVkGX" },
//           { name: "Female - Rachel", value: "21m00Tcm4TlvDq8ikWAM" },
//           { name: "Female - Sarah", value: "EXAVITQu4vr4xnSDxMaL" },
//         ],
//       },
//     ],
//   });

//   window.ai_speech_conf.push({
//     name: "Microsoft AI",
//     value: 0,
//     lang: [
//       {
//         name: "tr-TR",
//         voices: [
//           { name: "Erkek - Ahmet", value: "tr-TR-AhmetNeural" },
//           { name: "Erkek - Alloy", value: "en-US-AlloyTurboMultilingualNeural" },
//           { name: "Erkek - Hyunsu", value: "ko-KR-HyunsuMultilingualNeural" },
//           { name: "Erkek - Alessio", value: "it-IT-AlessioMultilingualNeural" },
//           { name: "Erkek - Ryan", value: "en-US-RyanMultilingualNeural" },
//           { name: "Erkek - Yunyi", value: "zh-CN-YunyiMultilingualNeural" },
//           { name: "Kadın - Ada", value: "en-GB-AdaMultilingualNeural" },
//           { name: "Kadın - Ava", value: "en-US-AvaMultilingualNeural" },
//           { name: "Kadın - Emel", value: "tr-TR-EmelNeural" },
//           { name: "Kadın - Emma", value: "en-US-EmmaMultilingualNeural" },
//           { name: "Kadın - Jenny", value: "en-US-JennyMultilingualNeural" },
//           { name: "Kadın - Nova", value: "en-US-NovaTurboMultilingualNeural" },
//           { name: "Kadın - Thalita", value: "pt-BR-ThalitaMultilingualNeural" },
//         ],
//       },
//       {
//         name: "en-US",
//         voices: [
//           { name: "Male - Ryan", value: "en-US-RyanMultilingualNeural3" },
//           { name: "Male - Brandon", value: "en-US-BrandonNeural" },
//           { name: "Male - Andrew", value: "en-US-AndrewNeural" },
//           { name: "Female - Emma", value: "en-US-EmmaNeural" },
//           { name: "Female - Cora", value: "en-US-CoraNeural" },
//           { name: "Female - Ava", value: "en-US-AvaNeural" },
//         ],
//       },
//     ],
//   });
// }

// if (window.ai_image_conf.length === 0) {
//   window.ai_image_conf.push({
//     name: "OpenAI",
//     value: 1,
//     sizes: [
//       { name: "1024x1024", value: "1024" },
//       { name: "1792x1024", value: "1792" },
//       { name: "1024x1792", value: "17922" },
//     ],
//     qualities: [
//       { name: "Standard", value: "0" },
//       { name: "HD", value: "1" },
//     ],
//     styles: [
//       { name: "Vivid", value: "0" },
//       { name: "Natural", value: "1" },
//     ],
//   });
// }

// Recorder/render-mode shortcut: the docker worker hits this URL with
// `?recorderMode=true&renderMode=true&navItemById=...`. Mounting the
// editor at all is wrong here — it wraps the visor in a Bootstrap Modal
// with its own header bar, which leaks into the captured frames as a
// grey "Aidea Brief …" strip. The standalone /index_visor.html serves
// the bare visor with no chrome, so we redirect to it before any React
// mounts. The visor frontend understands the same `?id=…&navItemById=…
// &recorderMode=true` params.
(function recorderModeShortcut() {
  if (typeof window === "undefined") return;
  if (window.location.pathname.includes("index_visor.html")) return;
  const params = new URLSearchParams(window.location.search);
  if (params.get("recorderMode") !== "true" && params.get("renderMode") !== "true") return;
  const target = "/index_visor.html" + window.location.search + window.location.hash;
  window.location.replace(target);
})();

// Editor only mounts with a valid token; otherwise AppErrorBoundary renders
// AuthRequiredModal on its own (children is null) instead of a blank screen.
const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);

bootEditor({
  hasValidToken,
  setEnvironment: setEnvironmentFromUrl,
  assetGrantReady,
  render: () => {
    if (hasValidToken) {
      const _appVersion = process.env.VISOR_BUNDLE_VERSION || "dev";
      window.APP_VERSION = _appVersion;
      console.log(
        "%c✏️  Editor  v" + _appVersion + " ",
        "background:#0f172a;color:#4ade80;font-weight:bold;font-size:13px;" +
          "padding:4px 14px;border-radius:6px;border-left:4px solid #22c55e;"
      );
    }

    root.render(
      <AppErrorBoundary initialAuthRequired={!hasValidToken}>
        {hasValidToken ? <ReduxProvider /> : null}
      </AppErrorBoundary>
    );
    console.log("✅ App rendered successfully");
  },
});
